import {
  BASE_API_URL,
  post,
} from '@/utils/http'

export * from './common'

// 获取录取结果
export const queryEnrollResultUrl = `${BASE_API_URL}/pz/zsxx/queryLqjg`
export const queryEnrollResult = (...args) => {
  return post(queryEnrollResultUrl, ...args)
}

// 获取录取结果查询条件
export const queryEnrollResultSearchListUrl = `${BASE_API_URL}/pz/zsxx/queryLqjgTerm`
export const queryEnrollResultSearchList = (...args) => {
  return post(queryEnrollResultSearchListUrl, ...args)
}

// 获取录取结果标题
export const queryEnrollResultTitleUrl = `${BASE_API_URL}/pz/zsxx/queryLqjgTitle`
export const queryEnrollResultTitle = (...args) => {
  return post(queryEnrollResultTitleUrl, ...args)
}

export const queryTenantNameUrl = `${BASE_API_URL}/zs/ty/queryTenantName`
export const queryTenantName = (...args) => {
  return post(queryTenantNameUrl, ...args)
}

export const queryEnrollProvinceUrl = `${BASE_API_URL}/pz/zsxx/queryFbsfList`
export const queryEnrollProvince = (...args) => {
  return post(queryEnrollProvinceUrl, ...args)
}

export const queryEnrollPublishDetailUrl = `${BASE_API_URL}/pz/zsxx/queryFbxq`
export const queryEnrollPublishDetail = (...args) => {
  return post(queryEnrollPublishDetailUrl, ...args)
}

export const queryEnrollPublicConfigUrl = `${BASE_API_URL}/pz/zsxx/queryFbpz`
export const queryEnrollPublicConfig = (...args) => {
  return post(queryEnrollPublicConfigUrl, ...args)
}

export const queryQtLqjgTitleUrl = `${BASE_API_URL}/qt/zscx/queryLqjgTitle
`
export const queryQtLqjgTitle = (...args) => {
  return post(queryQtLqjgTitleUrl, ...args)
}

export const queryQtLqjgTermUrl = `${BASE_API_URL}/qt/zscx/queryLqjgTerm
`
export const queryQtLqjgTerm = (...args) => {
  return post(queryQtLqjgTermUrl, ...args)
}

export const queryQtLqxxListUrl = `${BASE_API_URL}/qt/zscx/queryLqxxList
`
export const queryQtLqxxList = (...args) => {
  return post(queryQtLqxxListUrl, ...args)
}

export const queryQtLqcjTitleUrl = `${BASE_API_URL}/qt/zscx/queryLqcjTitle
`
export const queryQtLqcjTitle = (...args) => {
  return post(queryQtLqcjTitleUrl, ...args)
}

export const queryQtLqjcjTermUrl = `${BASE_API_URL}/qt/zscx/queryLqjcjTerm
`
export const queryQtLqjcjTerm = (...args) => {
  return post(queryQtLqjcjTermUrl, ...args)
}

export const queryQtCjxxListUrl = `${BASE_API_URL}/qt/zscx/queryCjxxList
`
export const queryQtCjxxList = (...args) => {
  return post(queryQtCjxxListUrl, ...args)
}
